import { Field, useForm, useFormState } from 'react-final-form';
import styles from './DebtSchedule.module.scss';
import MeritoRadioButton from '../../../Finance/components/RadioButton/MeritoRadioButton';
import { directorSelectOptionValidation } from '../../Director/directorHelper';
import { DebtList } from '../../../../components/DebtSchedule';
import { getDefaultDebt } from '../../../../components/DebtSchedule/debtHelpers';


const DebtSchedule = () => {
    const { getState, change } = useForm();

    // Next submits the form; once that fails, the cards show their missing
    // details, the way submitting reveals errors on the regular form fields
    const { submitFailed, values } = useFormState({ subscription: { submitFailed: true, values: true } });
    const hasDebt = values?.hasDebt;

    return (
        <>
            <div className={styles.fieldsContainer}>
                <div className={styles.questionCard}>
                    <Field name="hasDebt" validate={(values) => directorSelectOptionValidation(values)}>
                        {(props) => (
                            <MeritoRadioButton
                                {...props.input}
                                label="Does your brand have any debt?"
                                radioLabels={[
                                    { label: 'Yes', value: 'yes' },
                                    { label: 'No', value: 'no' },
                                ]}
                                name={props.input.name}
                                value={props.input.value}
                                onChange={(event) => {
                                    props.input.onChange(event);
                                    if (event.target.value === 'yes' && !getState().values?.debt?.length) {
                                        change('debt', [getDefaultDebt()]);
                                    }
                                    // Picking Yes adds the cards below the fold, so bring the first one
                                    // into view. Only on the user's pick, so loading a saved Yes doesn't
                                    // jump. setTimeout waits for the cards to render; "nearest" scrolls
                                    // just enough to show the card, keeping the question on screen.
                                    if (event.target.value === 'yes') {
                                        setTimeout(() => {
                                            document.getElementById('debt')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                                        }, 0);
                                    }
                                }}
                                error={props.meta.error}
                                touched={props.meta.touched}
                                size="md2"
                                isLabelBold={true}
                            />
                        )}
                    </Field>
                </div>
            </div>

            {hasDebt == 'yes' && (
                <Field name="debt" subscription={{ value: true }}>
                    {({ input }) => (
                        // id matches the "debt" error key, so the page's scroll-to-first-error lands here
                        <div id="debt">
                            <DebtList
                                debts={input.value || []}
                                // read the list at call time so async results never write over newer cards
                                onDebtsChange={(update) => change('debt', update(getState().values?.debt || []))}
                                apiBasePath="/underwriting/debt"
                                showErrors={submitFailed}
                            />
                        </div>
                    )}
                </Field>
            )}

        </>
    );
}

export default DebtSchedule;
